'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components = require('components');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Search, _Component);

  function Search() {
    (0, _classCallCheck3.default)(this, Search);
    return (0, _possibleConstructorReturn3.default)(this, (Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).apply(this, arguments));
  }

  (0, _createClass3.default)(Search, [{
    key: 'render',
    value: function render() {
      var rest = this.props;

      var emails = this.props.location.query.email;
      emails = Array.isArray(emails) ? emails : [emails];

      var cameras = this.props.location.query.camera;
      cameras = Array.isArray(cameras) ? cameras : [cameras];

      // Check if "admin" is in URL
      var isAdmin = this.props.location.query.admin;
      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Search' }),
        _react2.default.createElement(_components.CustomerSearch, rest),
        emails[0] !== undefined && emails.map(function (email) {
          return _react2.default.createElement(
            _containers.CustomerWrapper,
            { key: email, email: email },
            _react2.default.createElement(
              _components.Customer,
              null,
              _react2.default.createElement(_components.Camera, { isAdmin: isAdmin })
            )
          );
        }),
        cameras[0] !== undefined && cameras.map(function (sn) {
          return _react2.default.createElement(
            _containers.CameraWrapper,
            { key: sn, sn: sn },
            _react2.default.createElement(_components.Camera, { isAdmin: isAdmin })
          );
        })
      );
    }
  }]);
  return Search;
}(_react.Component), _class.propTypes = {
  location: _react.PropTypes.object
}, _temp);
exports.default = Search;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Search/Search.js
 ** module id = 1399
 ** module chunks = 0
 **/